
define('text!plugins/number/template.html',[],function () { return '<div class="row">\n    <div class="small-6 columns">\n        <div class="row">\n            <div class="small-10 columns">\n                <input type="text" class="numberInput" data-rv-value="model:value">\n            </div>\n        </div>\n    </div>\n</div>\n';});

